export const UploadFileType = {
  image: ['png', 'jpg', 'jpeg'],
  file: [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf',
    'zip',
    'tar',
    'rar'
  ],
  document: ['doc', 'docx', 'pdf'],
  sheet: ['xls', 'xlsx'],
  video: [
    'avi',
    'flv',
    'mpg',
    'mpeg',
    'mpe',
    'm1v',
    'm2v',
    'mpv2',
    'mp2v',
    'dat',
    'ts',
    'tp',
    'tpr',
    'pva',
    'pss',
    'mp4',
    'm4v',
    'm4p',
    'm4b',
    '3gp',
    '3gpp',
    '3g2',
    '3gp2',
    'ogg',
    'mov',
    'qt',
    'amr',
    'rm',
    'ram',
    'rmvb',
    'rpm'
  ]
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUpload/utils.ts